<template>
    <div class="pt-7 lg:pt-12">
        <!-- For Large Screen -->
        <div class="hidden lg:block max-w-7xl mx-auto lg:px-8">
            <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                <div
                    class="
                        px-8
                        py-3
                        bg-secondary-light
                        border-b border-gray-200
                    "
                >
                    <div class="bg-white w-full flex items-center rounded my-6">
                        <div class="flex-grow rounded">
                            <input
                                class="
                                    w-full
                                    px-6
                                    text-xs text-secondary
                                    font-medium
                                    tracking-wide
                                    focus:outline-none
                                "
                                v-model="keyword"
                                placeholder="Type a brand, model, or trim"
                                @keydown.enter="search"
                            />
                        </div>
                        <div
                            class="
                                flex-shrink
                                py-2
                                px-3
                                rounded-tr rounded-br
                                bg-primary
                                text-white text-xl
                                cursor-pointer
                                hover:bg-white hover:text-primary
                                transition-all
                                duration-500
                            "
                            @click="search"
                        >
                            <i class="icon-np-search"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- For Small Screen -->
        <div class="lg:hidden max-w-7xl mx-auto px-6">
            <div class="bg-white w-full flex items-center rounded-lg">
                <div class="flex-grow">
                    <input
                        class="
                            h-14
                            w-full
                            px-6
                            text-sm text-secondary
                            rounded-lg
                            font-medium
                            tracking-wide
                            focus:outline-none
                        "
                        v-model="keyword"
                        @keydown.enter="search"
                    />
                </div>
                <div
                    class="flex-shrink py-2 px-3 text-secondary text-2xl"
                    @click="search"
                >
                    <i class="icon-np-search"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        originalKeyword: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            keyword: null,
        };
    },
    mounted() {
        this.keyword = this.originalKeyword;
    },
    methods: {
        search() {
            this.$emit("search", this.keyword);
        },
    },
};
</script>
